import React from "react"
import { Box, Typography } from "@mui/material"

import AppOfficesBlockContainer from "@components/DataBlocks/OfficesContainer"
import { AppOfficesBlock } from '@components'


export default function airportsColumn() {
	return [{
		name: 'id_office_group_translation', label: 'Office Group',
		options: { display: 'excluded' }
	}, {
		name: 'pickUpFilters', label: 'Pick up',
		options: { display: 'excluded' }
	}, {
		name: 'dropDownFilter', label: 'Drop off',
		options: {
			display: 'excluded',
			customBodyRowRender: (value, { pickUpFilters }) => {
				if (!value) return 'Same Pick up'
				else if (pickUpFilters.length > 1) return 'Same Pick up'
				else if (pickUpFilters[0] === value) return 'Same Pick up'
				return value
			}
		}
	}, {
		name: "pickUp", label: "Pick up & Drop off",
		options: {
			filter: false,
			headerAlign: 'left',
			customBodyRowRenderLite: (value, { id_office_group_translation, dropDown, dropDownFilter }) => {
				return <Box sx={{ textWrap: 'nowrap', display: 'flex', alignItems: 'center', justifyContent: 'start', gap: 2 }}>
					{!!id_office_group_translation && <Typography variant="subtitle2">
						{id_office_group_translation}
					</Typography>}

					{!id_office_group_translation && <>
						<AppOfficesBlockContainer rows={value}/>
					</>}
					{!!dropDownFilter && <>
						<Typography sx={{ fontSize: 15, fontWeight: 'bold' }} >/</Typography>
						<AppOfficesBlock {...dropDown}/>
					</>}
				</Box>
			}
		}
	}]
}